import { useRef, useState } from "react";
import { Eraser, PenLine } from "lucide-react";
import SignatureCanvas from "react-signature-canvas";

export default function SignaturePad({ onSave, onCancel, saving = false }) {
  const ref = useRef(null);
  const [dirty, setDirty] = useState(false);

  const clear = () => {
    ref.current?.clear();
    setDirty(false);
  };

  const save = () => {
    if (!ref.current || ref.current.isEmpty()) return;
    const canvas = ref.current.getCanvas();
    const dataUrl = canvas.toDataURL("image/png");
    onSave(dataUrl);
  };

  return (
    <div>
      <p className="text-sm text-zinc-600 mb-2 flex items-center gap-2">
        <PenLine className="w-4 h-4" /> Assine abaixo para aprovar o orçamento
      </p>
      <div className="rounded-md border border-zinc-300 bg-white overflow-hidden">
        <SignatureCanvas
          ref={ref}
          onEnd={() => setDirty(true)}
          canvasProps={{
            className: "w-full h-48 touch-none",
            "data-testid": "signature-canvas",
          }}
          penColor="#14243D"
          backgroundColor="rgba(255,255,255,1)"
        />
      </div>
      <div className="flex items-center justify-between mt-3">
        <button
          type="button"
          onClick={clear}
          data-testid="signature-clear-btn"
          className="inline-flex items-center gap-1 text-xs text-zinc-500 hover:text-zinc-800"
        >
          <Eraser className="w-3 h-3" /> Limpar
        </button>
        <div className="flex gap-2">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 rounded-md border border-zinc-200 text-sm font-medium"
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={save}
            disabled={!dirty || saving}
            data-testid="signature-save-btn"
            className="px-4 py-2 rounded-md bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-semibold disabled:opacity-60"
          >
            {saving ? "Enviando..." : "Confirmar aprovação"}
          </button>
        </div>
      </div>
    </div>
  );
}
